import { useTranslation } from 'react-i18next';
import { useSystemStore } from '@/store/systemStore';

const ENV_CLASSES = {
  development: 'bg-primary/10 text-primary',
  testing: 'bg-fuchsia-100 text-fuchsia-700',
  production: null,
} as const;

export default function EnvironmentBadge() {
  const { t } = useTranslation();
  const { settings } = useSystemStore();
  const env = settings?.environment_type ?? 'production';
  const className = ENV_CLASSES[env];

  if (!className) return null;

  return (
    <div className="flex justify-center">
      <span className={`inline-block text-dense font-semibold px-3 py-1 rounded-full ${className}`}>
        {t(`common.env_${env}`)}
      </span>
    </div>
  );
}
